/**
 * AdminSourcingDesk — the staff-in-the-loop cockpit for agentic sourcing
 * (docs/ASKA-PLUS-AGENTIC-SOURCING.md §3.3, §11 step 11). Per want, staff see every
 * supplier RFQ thread and can review/edit/approve a draft before it sends, take a
 * thread over, correct a parsed quote, and pause a want (the kill switch). Reuses
 * the agent-cockpit widget shapes (transcript + waLink + approve/dismiss — the same
 * shape as AgentThreadPanel / agent/router.ts::present).
 *
 * ⚠️ SCAFFOLD (§10, §13). Desktop-only (admin has no mobile surface — CLAUDE.md).
 * It is FLAG-GATED into the Admin console: the tab only mounts when
 * canUseAgenticSourcing() (i.e. SOURCING_RFQ_LIVE armed), so on the v0 3-tab
 * console it is completely absent — zero new surface, no read-only-sweep change.
 * The live body (the want queue, the per-thread cockpit widgets, the pause button)
 * is a phase body; this scaffold renders the shell + an explanatory empty state so
 * the tab exists the moment the flag flips.
 */

export function AdminSourcingDesk() {
  return (
    <div className="space-y-6" data-testid="admin-sourcing-desk">
      <div>
        <h2 className="font-serif text-xl font-bold text-ink">Sourcing Desk</h2>
        <p className="mt-1 text-sm text-soft leading-relaxed">
          Every agentic-sourcing want and its supplier RFQ threads. Review a draft before it
          sends, take over a thread, correct a parsed quote, or pause a want. Accepting a quote
          is a member/staff action — the agent never mints an order.
        </p>
      </div>

      {/* TODO(agentic-sourcing:phase2): the want queue + per-thread cockpit. Reuse
          the AgentThreadPanel widget shapes (transcript, wa.me deep link,
          approve/dismiss, take-over) driven by GET /admin/sourcing/wants +
          the per-thread present() payload. Include the per-want "pause sourcing"
          kill switch (§3.3) — parks every thread on the want far-future. */}
      <div className="rounded-card border border-border bg-paper p-6">
        <p className="text-sm text-soft">
          No active want-lists. When members start sourcing, their wants and the agent’s supplier
          threads appear here for review.
        </p>
      </div>
    </div>
  )
}

export default AdminSourcingDesk
